import { connect } from 'react-redux'
import { compose } from 'recompose'

import { dataFetched, makesMutations } from 'data/graphql'
import { createErrorToasterMessage } from 'data/ui/actions'

import { updateUserPreferences } from 'remote/users'
import { bookmarkedNoteIdsFetched } from 'data/notes/actions'

export const providesUserPreferencesMutations = compose(
  connect(
    null,
    {
      dataFetched,
      createErrorToasterMessage,
      bookmarkedNoteIdsFetched,
    }
  ),
  makesMutations({
    query: updateUserPreferences,
    mutationPropName: 'updateUserPreferences',
    getOnResultFromProps: ({
      dataFetched,
      createErrorToasterMessage,
      bookmarkedNoteIdsFetched,
    }) => ({ result }) => {
      const { data, errors } = result
      if (errors && errors.length > 0) {
        createErrorToasterMessage({ title: errors[0].message })
      } else {
        const { updateUserPreferences } = data
        bookmarkedNoteIdsFetched(updateUserPreferences.bookmarkedNoteIds)
        dataFetched(updateUserPreferences)
      }
    },
  })
)
